// extracted by mini-css-extract-plugin
module.exports = {"stickyColumn":"__2-1_stickyColumn__VJ7RR","grid":"__2-1_grid__oGaNk"};